import React from "react";
interface IconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}
const AngleDown: React.FC<IconProps> = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" {...props}>
      <path
        d="M24.7 28.633L40 43.9l15.3-15.267 4.7 4.7-20 20-20-20 4.7-4.7z"
        fill="#fff"
      />
    </svg>
  );
};

const MemoAngleDown = React.memo(AngleDown);
export default MemoAngleDown;
